var map = {
	"./calendar.png": 2978,
	"./call.png": 2979,
	"./check.png": 2980,
	"./filter.png": 2981,
	"./lead.png": 938,
	"./leaf.png": 2982,
	"./leaf0ld.png": 2983,
	"./load.png": 2984,
	"./math.png": 2985,
	"./mathold.png": 2986,
	"./opportunities.png": 939,
	"./people.png": 2987,
	"./phone.png": 2988,
	"./review.png": 940,
	"./sad.png": 485,
	"./shield.png": 2989,
	"./shieldold.png": 2990,
	"./upload.png": 2991
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2977;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard ^\.\/.*\.png$
// module id = 2977
// module chunks = 0